import { useState } from "react";
import { Tooltip } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import ListIcon from '@material-ui/icons/List';
const DialogDescripcion = (props) => {
    const { Descripcion } = props
    const [open, setOpen] = useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    return (
        <div>
            <Tooltip title="Ver descripción">
                <span>
                    <Button
                        variant="text"
                        color="primary"
                        onClick={handleClickOpen}
                    >
                        <ListIcon />
                    </Button>
                </span>
            </Tooltip>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                maxWidth='md'
            >
                <DialogTitle id="form-dialog-title">Descripción extra</DialogTitle>
                <DialogContent>
                    <div style={{maxHeight: "400px", overflowY: "scroll", padding: "15px"}} dangerouslySetInnerHTML={{ __html: `${Descripcion}` }} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
export default DialogDescripcion